import { Range } from 'types';

const addRangesFormIndex = (ranges: Range[], index: number): Range[] => {
  const result: Range[] = [];
  for (let i = index; i < ranges.length; i += 1) {
    result.push(ranges[i]);
  }
  return result;
};

export const addRangeToRanges = (range: Range, ranges: Range[]) => {
  const result: Range[] = [];
  let added = false;

  if (ranges?.length === 0) {
    return [range];
  }

  const firstRange = ranges[0];
  if (firstRange.from === range.to + 1) {
    result.push({ ...range, from: range.from, to: firstRange.to });
    const otherRanges = addRangesFormIndex(ranges, 1);
    result.push(...otherRanges);
    return result;
  }

  for (let i = 0; i < ranges.length; i += 1) {
    const currentRange = ranges[i];

    if (i === ranges.length - 1) {
      if (currentRange.to + 1 === range.from) {
        result.push({ ...range, from: currentRange.from, to: range.to });
      } else if (!added) {
        result.push(currentRange);
        result.push(range);
      } else {
        result.push(currentRange);
      }
    } else {
      const nextRange = ranges[i + 1];
      if (currentRange.from === range.to + 1) {
        result.push({ ...range, from: range.from, to: nextRange.to });
        added = true;
        i += 1;
      }
      if (
        currentRange.to + 1 === range.from &&
        range.to + 1 === nextRange.from
      ) {
        result.push({ ...range, from: currentRange.from, to: nextRange.to });
        added = true;
        i += 1;
      } else if (currentRange.to + 1 === range.from) {
        result.push({ ...range, from: currentRange.from, to: range.to });
        added = true;
      } else if (range.to + 1 === nextRange.from) {
        result.push(currentRange);
        result.push({ ...range, from: range.from, to: nextRange.to });
        added = true;
        i += 1;
      } else if (currentRange.to < range.from && range.to < nextRange.from) {
        result.push(currentRange);
        result.push(range);
        added = true;
      } else {
        result.push(currentRange);
      }
    }
  }
  return result;
};
